import React from 'react';
import { Checkbox } from '@mui/material';
import { NoItemsYet, SimpleTooltip, TextRow } from 'components';
import { targetChooseDetailsFromLibraryNotYet } from './constants';

export const TargetsChooseDetailsFromLibrary = ({ currentFolder, selectedMap, toggleItem }) => {
    return (
        <div className="targets-tab-details-wrapper">
            {currentFolder?.targets?.length ? (
                <div className="targets-tab-details-block">
                    {currentFolder?.targets?.map((target, index) => (
                        <div className="targets-tab-details-item-row" key={index}>
                            <SimpleTooltip title={''} placement="top-start">
                                <Checkbox
                                    checked={selectedMap.get(currentFolder.id)?.has(target.id) || false}
                                    onChange={(e) =>
                                        toggleItem({
                                            folderId: currentFolder.id,
                                            targetId: target.id,
                                            checked: e.target.checked,
                                        })
                                    }
                                    name={'checkBox'}
                                    style={{ padding: 16, color: '#0C66E4' }}
                                />
                            </SimpleTooltip>

                            <div className="targets-tab-details-item-cell" style={{ width: 'fit-content' }}>
                                {index + 1}
                            </div>

                            <div className="targets-tab-details-item-cell" style={{ width: '25%' }}>
                                <TextRow name={target?.name} />
                            </div>

                            <div className="targets-tab-details-item-cell" style={{ width: '69%' }}>
                                <TextRow name={target?.description} />
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <NoItemsYet
                    image={targetChooseDetailsFromLibraryNotYet.image}
                    text={targetChooseDetailsFromLibraryNotYet.title}
                    subTitle={targetChooseDetailsFromLibraryNotYet.subTitle}
                    containerStyles={{
                        position: 'static',
                    }}
                    height="fit-content"
                />
            )}
        </div>
    );
};
